/**
 * useFinancialProfile
 * Fetches the full financial profile (59+ fields) from /backoffice/profiles/{directoryId}
 */
import { useQuery } from '@tanstack/react-query';
import { getFinancialProfile } from '@/services/credit-engine.service';
import { PARTNER_ID } from '@/constants';

export function useFinancialProfile(directoryId: string) {
  const query = useQuery({
    queryKey: ['backoffice', 'profiles', directoryId, PARTNER_ID],
    queryFn: () => getFinancialProfile(directoryId, PARTNER_ID),
    enabled: Boolean(directoryId),
  });

  return {
    profile: query.data?.data ?? null,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
